import { config } from '../config';
import { handleResponse } from "../helpers/response";
import i18n from 'i18next';

export const PUT_HISTORY_ITEMS = 'PUT_HISTORY_ITEMS';

/**
 * Gets items history data
 *
 * @param ids
 * @returns {function(...[*]=)}
 */
export const getsHistoryItems = (ids) => {
    return (dispatch, getState) => {
        var link = `${config.apiUrl}api/catalog/history/${i18n.language}`;
        // const formData  = new FormData();
        // dispatch(showLoader());
        // formData.append("product_ids", ids);
        // formData.append('tok_', getState().user.userInfo._tok );
        const formData = { "product_ids": ids, 'tok_': getState().user.userInfo._tok };
        fetch(link, { method: 'POST', body: JSON.stringify(formData) }).then(handleResponse).then(json => {
            dispatch(setHistoryItems(json));
            // dispatch(hideLoader());
        })
    }
}

/**
 * Sets item data
 *
 * @param json
 * @returns {{item: *, type: string}}
 */
export const setHistoryItems = (data) => {
    console.log('setHistoryItems->data', data);
    return {
        type: PUT_HISTORY_ITEMS,
        historyItems: data.pagination,
        showItemLoader: false
    }
}